import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

const alert1 = 'rgba(208, 2, 27, 0.1)';
const alert2 = 'rgb(237,226,228)';

export const StyledRoomCard = styled.div<{ hasError: boolean; isRemoved: boolean }>`
  background-color: ${({ hasError, isRemoved }) => {
    if (hasError && isRemoved) return alert2;
    if (hasError) return alert1;
    if (isRemoved) return color.neutral30;
    return color.neutral20;
  }};
  border-bottom: ${toRem(1)} solid ${color.neutral30};

  .group-code {
    word-break: break-all;
  }

  .cta-icon {
    color: ${color.bvyAccent20};
    background: transparent;
    text-decoration: underline;
    .cta-icon-label {
      display: none;
    }
    .icon-renew::before {
      transform: rotateY(180deg);
    }
    .icon-clear,
    .icon-renew {
      font-size: ${font.fontL};
      font-weight: ${font.fontWeightMedium};
    }
    &:hover {
      .cta-icon-label {
        display: inline;
        color: ${color.bvyAccent20};
      }
      .icon-clear,
      .icon-renew {
        display: none;
      }
    }
  }
`;
